export const sanitizeInvoiceNumber = value => (typeof value === 'string' ? value.replace(/\s+/g, '') : value);

export const preventInvoiceNumberWhitespace = event => {
  if (event.key === ' ') {
    event.preventDefault();
  }
};
